import React, { Component, useEffect, useRef, useState} from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Dropdown, Navbar, Container, Row, Button, Col, Table, Spinner, Card, Badge, Modal } from 'react-bootstrap'
import Nav from 'react-bootstrap/Nav'
import { key_local_client, key_local_storage_cart, key_local_storage_pedidos, key_local_storage_user, urlapi } from '../../lib/backend/data'
import { url_images } from '../../lib/backend/data'
import { PiWarehouse } from "react-icons/pi";
import { obtenerFechaZonaHorariaLocal } from '../../lib/helpers/dates'
import { toast } from 'react-toastify'
import { formatearRUTChileno, formatoMoneda, formatoRut, validarRut } from '../../lib/helpers/helpers'
import CrearEmpresa from '../../subComponents/empresas/crear_modal'
import SucursalesSelector from '../../subComponents/bodegas/selector'
import ConfiguracionSelector from '../../subComponents/bodegas/selector'
import { FaCircleMinus, FaCirclePlus, FaFileInvoice } from "react-icons/fa6";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";
import { CiCreditCard1 } from "react-icons/ci";
import { IoReceiptOutline } from "react-icons/io5";
import { HiOutlineIdentification } from "react-icons/hi2";
import PdfViewer from './pdf_viewer'
import { confirmAlert } from 'react-confirm-alert'

let metodos_pago = [
  { key: "E", value:"Efectivo" },
  { key: "I", value:"Depósito en C/C - Transferencia" },
  { key: "T", value:"Tarjeta de crédito" },
  { key: "D", value:"Tarjeta de débito" },
]

const Carrito = (props) => {
    let carrito = props.carrito ? props.carrito : []
    const user = JSON.parse(localStorage.getItem(key_local_storage_user))
    const [show_drawer, setShowDrawer] = useState(false)
    const [tipoDoc, setTipoDoc] = useState("39")
    const [clientes, setClientes] = useState([
      {value: 2, label: "Cliente genérico"}
    ])
    const [ showPDF, setShowPDF ] = useState(false)
    const [ showModalPagos, setShowModalPagos ] = useState(false)
    const [clienteEspecifico, setClienteEspecifico] = useState(false)
    const [loadingBuscarCliente, setLoadingBuscarCliente] = useState(false)
    const [listaClientes, setListaClientes] = useState([])
    const mensaje_emitiendo_default = "Emitiendo DTE"
    const [loadingClientes, setLoadingClientes] = useState(false)
    const [loadingMetodosPago, setLoadingMetodosPago] = useState(false)
    const [clienteSeleccionado, setClienteSeleccionado] = useState(clientes.length > 0 ? clientes[0].value : false)
    const [ clienteSeleccionadoDetalle, setClienteSeleccionadoDetalle ] = useState(false)
    const [descuentoSeleccionado, setDescuentoSeleccionado] = useState(false)
    const [metodosPago, setMetodosPago] = useState([])
    const [pagos, setPagos] = useState([])
    const [termId, setTermId] = useState(false)
    const [salesManId, setSalesManId] = useState(1)
    const [nombreCliente, setNombreCliente] = useState("")
    const [posId, setPosId] = useState(null)
    const [wareHouseId, setWareHouseId] = useState("")
    const [fechaPedido, setFechaPedido] = useState("")
    const [motivo, setMotivo] = useState("")
    const [branchId, setBranchId] = useState()
    const [autorizado, setAutorizado] = useState(false)
    const [allow_invoice_witouth_payment, setAllowInvoiceWitouthPayment] = useState(false)
    const [iva, setIva] = useState(19)
    const [facturando, setFacturando] = useState(false)
    const [ultimoDocGenerado, setUltimoDocGenerado] = useState(localStorage.getItem("ultimo_doc_generado") ? localStorage.getItem("ultimo_doc_generado") : false)
    const [ mensajeFacturando, setMensajeFacturando ] = useState(mensaje_emitiendo_default)
    const [rut, setRut] = useState("")
    const [pdfFile, setPdfFile] = useState(null);
    const [ tokenLaudus, setTokenLaudus ] = useState(localStorage.getItem("tokenLaudus") ? localStorage.getItem("tokenLaudus") : false)
    
    const [printerIPAddress, setPrinterIPAddress] = useState("192.168.1.120");
    const [printerPort, setPrinterPort] = useState("9100");
    const [textToPrint, setTextToPrint] = useState("");
    const [connectionStatus, setConnectionStatus] = useState("");

    const ePosDevice = useRef();
    const printer = useRef();
    const STATUS_CONNECTED = "Connected";

    const solicitarSeteoAutomaticoCliente = (cliente_guardado) => {
      return confirmAlert({
          title: `Definir ${cliente_guardado.name}`,
          message: `Deseas seleccionar el cliente ${cliente_guardado.name} como cliente de el carrito?`,
          buttons: [
            {
              label: 'SI',
              onClick: () => {
                setClienteEspecifico(true)
                setClienteSeleccionado(cliente_guardado.customerId)
                setClienteSeleccionadoDetalle(cliente_guardado)
              }
            },
            {
              label: 'NO',
              onClick: () => {
                localStorage.setItem(key_local_client, "")
              }
            }
          ]
        })
  }

    const getUsuario = async () => {
      let loading = 'loadingUsuario'
      return fetch(`${urlapi}/usuarios/cuenta`,{
          method:'GET',
          headers: {
              'Content-Type':'application/json',
              'Authorization': `Bearer: ${user.tokenSession}`
          }
      })
      .then(res => {
          return res.json()
      })
      .then(res => {
          if(!res){
          } else if(res.errorMessage){
          } else if(res._id){
            if(res.warehouseId) setWareHouseId(res.warehouseId)
            if(res.salesmanId) setSalesManId(res.salesmanId)
            if(res.posId) setPosId(res.posId)
            const instancia_sesion = user
            instancia_sesion.data = res
              localStorage.setItem(key_local_storage_user, JSON.stringify(instancia_sesion))
          }
            const cliente_guardado = localStorage.getItem(key_local_client)
            if(cliente_guardado){
              const parseCliente = JSON.parse(cliente_guardado)
              solicitarSeteoAutomaticoCliente(parseCliente)
            }
          return false
      })
      .catch(error => error)
  }

    const obtenerMetodosPago = async () => {
      return fetch(`${urlapi}/invoice/metodospago`,{
        method:'GET',
        headers: {
            'Content-Type':'application/json',
            'Authorization': `Bearer: ${user.tokenSession}`
        }
    })
    .then(res => {
        if(res.status === 401) return window.location = '/login'
        return res.json()
    })
    .then(res => {
        if(!res){
            // toast.error('Sin datos')
            return false
        } else if(res.errorMessage){
            toast.error(res.errorMessage)
            return false
        } else if(Array.isArray(res) !== false){

          let nuevas = [
            { value: "", label: "Selecciona"},
          ]
          res.map(p => {
            nuevas.push({ value: p.termId, label: p.name })
          })
            setMetodosPago(nuevas)
            // if(nuevas.length > 1) setTermId(nuevas[2].value)
        }
        return setLoadingMetodosPago(false)
    })
    .catch(error => {
        toast.error("Error al consultar métodos de pago, intente nuevamente")
        return setLoadingMetodosPago(false)
    })
    }

    const verificarAutorizacionPago = async () => {
      const autorizar_pago = await obtenerCuenta()
      setAutorizado(autorizar_pago)
    }

    const validatePrinter = () => {
      let ePosDev = new window.epson.ePOSDevice();
      ePosDevice.current = ePosDev;

      ePosDev.connect(printerIPAddress, printerPort, (data) => {
        if (data === "OK") {
          ePosDev.createDevice(
            "local_printer",
            ePosDev.DEVICE_TYPE_PRINTER,
            { crypto: true, buffer: false },
            (devobj, retcode) => {
              if (retcode === "OK") {
                printer.current = devobj;
                setConnectionStatus(STATUS_CONNECTED);
              } else {
                throw retcode;
              }
            }
          );
        } else {
          throw data;
        }
      });
    }

    const mostrarPDF = (blob) => {
      const url = URL.createObjectURL(blob);
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.style.width = '100%';
      iframe.style.height = '500px';
      setShowPDF(true)
      setTimeout(() => {
        if(document.getElementById('pdf_container')) {
          document.getElementById('pdf_container').innerHTML = ''
          document.getElementById('pdf_container').appendChild(iframe)

          iframe.onload = () => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
            URL.revokeObjectURL(url);
          };
        }
      }, 200);
    }
    
    const mostrarPDFV3 = (blob) => {
      const url = URL.createObjectURL(blob);

      // Abrir la URL del Blob en una nueva ventana
      const newWindow = window.open(url, '_blank');
    
      if (newWindow) {
        // Esperar a que la nueva ventana cargue completamente el contenido
        newWindow.onload = function() {
          // Esperar un poco más para asegurarse de que el PDF se haya cargado completamente
          setTimeout(() => {
            // Ejecutar la función de impresión en la nueva ventana
            newWindow.print();
    
            // Cerrar la nueva ventana después de imprimir
            newWindow.onfocus = () => {
              newWindow.close();
              URL.revokeObjectURL(url); // Limpiar la URL del Blob
            };
          }, 500); // Puede ser necesario ajustar este tiempo según el tamaño del PDF y la velocidad de carga
        };
      } else {
        console.error('No se pudo abrir la ventana para imprimir el PDF');
      }
    }

    const mostrarPDF2 = (blob) => {
      setPdfFile(URL.createObjectURL(blob));
      setShowPDF(true)
    }

    useEffect(() => {
      getUsuario()
      // buscarPDF('E00001104','eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXlsb2FkIjoiTzZ4M3FsL0Nra2pzSkxldHprMkNORWt0U1FPd21POWoxMi9PUkF6aHFHQkdiOWtzMXNkYW9Bb0JNUStMd3ZVZStnQnAvZVRXWXh1YkhoVXNCS2xwMTNQM1BLNk43WjRmRDdMYkEvNmcvUWRYemI4NzkzbFVYZExPWUJRejRmYmdqVkJDNGxuTW9JeGZ6TksydktlNUpoVVB3MjIvYmh6Yy9JSUVrTjFyUm1maU9DejV4Q3QzemZ6OFhFZGFSUFQ2ZWloUnJzb1dxYXJZbjM5cFRpU3cxSmhNWlc3c1JHaXpEWUxWZ1AzQ3NoRU16U1VqK1V3U0R6V0pOSVRZZ1c1cWdrb210SkFzbmtrS24zdHRNSG9OS0pBQ0p1QWJ4R2YxL0VTakVvRkx5SmRZWTFiOGk0bDFUSGdFWks5d0V3K05rTC9pdHlyTUJiaHYvS1dPNnRyZFR0ZVBHZz09In0.CJmzDXIiGvL6_DniPxpF9jRhdJb_hwXMX0HewIQraX4')
      window.onload = () => {
       // validatePrinter()
      };
        verificarAutorizacionPago()
        if(carrito.length < 1){
            if(localStorage.getItem(key_local_storage_cart)){
                const parseCart = JSON.parse(localStorage.getItem(key_local_storage_cart))
                carrito = parseCart
            }
        }
        obtenerMetodosPago()
    }, [])

    const toggleDrawer = (e) => {
        setShowDrawer(false)
    }

    const limpiarCarrito = () => {
      if(props.cleanCart){
        props.cleanCart()
      }
      setPagos(prev => [...[], ...[]])
    }

    const handleChangeCantidad = (e) => {
        const { name, value } = e.target
        const i = carrito.findIndex(p => p._id === name)
        if(i < 0) return false
        carrito[i].cantidad = value
        if(props.onChangeCarrito) props.onChangeCarrito(carrito)
        return false
    }
    
    const operacionMath = (op, name) => {

        const i = carrito.findIndex(p => p._id === name)
        if(i < 0) return false
        let valor = carrito[i].cantidad

        if(op === "+"){
            valor = parseInt(carrito[i].cantidad) + 1
        } else {
            valor = Math.max(1, parseInt(carrito[i].cantidad) - 1)
        }

        carrito[i].cantidad = valor
        if(props.onChangeCarrito) props.onChangeCarrito(carrito)
        return false
    }

    const guardarUltimoDoc = (val) => {
      localStorage.setItem("ultimo_doc_generado", val)
      setUltimoDocGenerado(val)
    }

    const buscarPDF = async (invoiceId, tok) => {
      setFacturando(true)
      setMensajeFacturando("Generando PDF")
      return fetch(`https://api.laudus.cl/sales/invoices/${invoiceId}/pdf?NumberOfCopies=1&ContentDisposition=inline`,{
        method:'GET',
        headers: {
            'Content-Type':'application/json',
            'Authorization': `Bearer: ${tok}`
        }
    })
    .then(res => {
        if(res.status === 401) {
          setFacturando(false)
          return toast.error("NO autorizado para consultar PDF")
        }
        return res.blob()
    })
    .then(blob => {
      setFacturando(false)
      if(blob){
        mostrarPDFV3(blob)
        // var url = window.URL.createObjectURL(blob)
        // window.open(url, '_blank');
      }
      return setFacturando(false)
    })
    .catch(error => {
        toast.error("Error al consultar la información, intente nuevamente")
        return setFacturando(false)
    })
    }

    const handleChangeMotivo = (e) => {
      const { value } = e.target
      return setMotivo(value)
    }
    
    const handleChangeFechaPedido = (e) => {
      const { value } = e.target
      return setFechaPedido(value)
    }

    const campoFechaPedido = () => {
      if(tipoDoc.toString() !== "1000") return false
      return<Col md={12}><div className='mb-3 mt-2'>
        <label className='form-control-label d-block'>Fecha del pedido</label>
        <input className='form-control' type="date" onChange={handleChangeFechaPedido} />
      </div></Col>
    }

    const campoMotivo = () => {
      if(tipoDoc.toString() !== "52") return false
      return<Col md={12}><div className='mb-3'>
        <label className='form-control-label d-block'>Motivo</label>
        <input className='form-control' onChange={handleChangeMotivo} />
      </div></Col>
    }

    const obtenerCuenta = async () => {
      return fetch(`${urlapi}/session/details`,{
          method:'GET',
          headers: {
              'Content-Type':'application/json',
              'Authorization': `Bearer: ${user.tokenSession}`
          }
      })
      .then(res => {
          if(res.status === 401) return window.location = '/login'
          return res.json()
      })
      .then(res => {
          if(!res){
            return false
          } else if(res.errorMessage){
            return false
          } else if(res._id){
            user.data = res
            localStorage.setItem(key_local_storage_user, JSON.stringify(user))
            return res.allow_invoice_witouth_payment === true ? true : false
          }
          return false
        })
      .catch(error => false)
  }

    const facturar = async () => {

      
      
      if(tipoDoc === "39") {
        // Boleta electrónica
        if(user.data.allow_emit_boleta !== true) return toast.error("Tipo de documento no permitido para tu usuario")

      } else if(tipoDoc === "33") {
        // Factura electrónica
        if(user.data.allow_emit_factura !== true) return toast.error("Tipo de documento no permitido para tu usuario")

      } else if(tipoDoc === "52") {
        // Guia de despacho electrónica
        if(user.data.allow_emit_guia_despacho !== true) return toast.error("Tipo de documento no permitido para tu usuario")

      } else if(tipoDoc === "1000") {
        // Pedido para picking
        if(user.data.allow_emit_guia_pedido !== true) return toast.error("Tipo de documento no permitido para tu usuario")
        if(!fechaPedido) return toast.error("Selecciona la fecha del pedido")

      } else if(tipoDoc === "1001") {
        // Cotización
        if(user.data.allow_emit_cotizacion !== true) return toast.error("Tipo de documento no permitido para tu usuario")

      } 
      
      
      let isGuiaDespacho = false
//        if(!termId) return toast.error("Selecciona un método de pago")
        if(!user.data.sucursalId) return toast.error("No tienes sucursal asignada a tu usuario")

        if(carrito.length < 1) return toast.error("Agrega al carrito al menos un producto")
        let ids_descuentos = []
        for( const pro of carrito ){
          if(!pro.descuentos) continue
          if(Array.isArray(pro.descuentos) !== true) continue
          if(pro.descuentos.length < 1) continue
          ids_descuentos = [...ids_descuentos, ...pro.descuentos]
        }

        setFacturando(true)

        if(ids_descuentos.length > 0){
          const { allow } = await validarDescuentos(ids_descuentos) 
          if(allow === false) {
            setFacturando(false)
            return toast.error("Descuentos aplicados no válidos")
          }
        }

        const fecha = obtenerFechaZonaHorariaLocal()
        if(tipoDoc.toString() === "52") isGuiaDespacho = true

        let motivo_guia = ''
        if(isGuiaDespacho) motivo_guia = motivo

        let items = []
        let calcular_total = carrito.reduce((prev, next) => {
          let cantidad = parseInt(next.cantidad)
          if(isNaN(cantidad)) cantidad = 0
          return prev + (next.precio * cantidad)
        }, 0)

        if(calcular_total < 1) {
          setFacturando(false)
          return toast.error("Monto de venta inválido")
        }

        for( const pro of carrito ){
          if(!pro.id) {
            setFacturando(false)
            return toast.error(`${pro.titulo} no está sincronizado, no posee ID`)
          }

          const sub_total = pro.cantidad * pro.precio

          const precio_neto = (pro.precio / 1.19).toFixed(2)
          const iva = Math.round((pro.precio - precio_neto) * pro.cantidad)

          const payload_producto = {
            "product": {
              "productId": pro.id,
              "sku": pro.codigo,
              "description": pro.titulo
            },
            "quantity": pro.cantidad,
            "originalUnitPrice": precio_neto,
            "unitPrice": precio_neto,
            "VAT": iva,
            "VATRate": 19.0
          }
          items.push(payload_producto)
        }
        
        let payload = {
            "docType": {
              "docTypeId": parseInt(tipoDoc),
            },
            "customer": {
              "customerId": clienteSeleccionado
            },
            "warehouse": {
              "warehouseId": wareHouseId
            },
            "salesman": {
              "salesmanId": salesManId,
            },
            "pos": {
              "posId": posId
            },
            "branch": {
              "branchId": user.data.sucursalId
            },
            "SII_transactionType": "1",
            "nullDoc": false,
            "issuedDate": fecha,
            "dueDate": fecha,
            "payInOriginalCurrency": true,
            "purchaseOrderNumber": "",
            "deliveryCost": 0,
            "deliveryNotes": motivo_guia,
            "deliveryVehiclePlate": "",
            "bypassCreditLimit": true,
            "notes": "",
            "createAccounting": true,
            "items": items,
            pagos
          }

          if(["39","33","52"].includes(tipoDoc)){
            if(pagos.length < 1) {

                if(allow_invoice_witouth_payment !== true) {
                  setFacturando(false)
                  return toast.error("No agregaste ningún método de pago, agrega al menos un tipo de pago")
                }
                const autorizar_pago = await obtenerCuenta()
                if(autorizar_pago !== true) {
                  setFacturando(false)
                  return toast.error("Operación no autorizada, recarga la página para refrescar la información")
                }
                
              } else {
                const faltantes = pagos.filter(p => typeof p.tipo === "undefined" || typeof p.monto === "undefined" || !p.tipo ).length
                if(faltantes > 0) {
                  setFacturando(false)
                  return toast.error("Debes configurar todos los pagos")
                }

                const invalidos = pagos.filter(p => {
                  if(isNaN(parseInt(p.monto))) return true
                }).length
                if(invalidos > 0) {
                  setFacturando(false)
                  return toast.error("Debes configurar el monto de todos los pagos")
                }

                const total_sumado = pagos.reduce((prev,next) => prev + next.monto, 0)
                if(total_sumado !== calcular_total ) {
                  setFacturando(false)
                  return toast.error("Monto de pagos no coincide con el monto de venta")  
                }

              }
            }

            // SETEAR FORMA DE PAGO

            if(tipoDoc.toString() === "39"){
              
              payload.term = {
                termId: "05",
                name: "SII Contado"
              }

            } else if(tipoDoc.toString() === "33"){
              
              if(pagos.length > 0){

                payload.term = {
                  termId: "05",
                  name: "SII Contado"
                }

              } else {
                payload.term = {
                  termId: "06",
                  name: "SII Credito"
                }
              }
            }

            let precio_sin_iva = false

            if(["1001","1000"].includes(tipoDoc)){
              // VALIDACIONES DE COTIZACIONES
              if(!clienteSeleccionadoDetalle) {
                setFacturando(false)
                return toast.error("Selecciona un cliente")
              }
              precio_sin_iva = true
            }
            // VALIDACIONES DE FACTURA, NO PUEDE IR SIN CLIENTE
            if(["33"].includes(tipoDoc)) if(!clienteSeleccionadoDetalle) {
              setFacturando(false)
              return toast.error("Selecciona un cliente")
            }

            if(isGuiaDespacho === true){
            payload.deliverySIIType = "1"
            payload.isSale = true
            payload.term = {
                  termId: "05",
                  name: "SII Contado"
            }
            delete payload.SII_transactionType
          }

          const enviar = {
            carrito,
            cliente: clienteSeleccionadoDetalle,
            payload,
            user: user.data,
            fecha_pedido: fechaPedido
          }

          setMensajeFacturando(mensaje_emitiendo_default)
          return fetch(`${urlapi}/invoice`,{
            method:'POST',
            body: JSON.stringify(enviar),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return window.location = '/login'
            return res.json()
        })
        .then(res => {
            if(!res){
                toast.error('Sin datos')
                return setFacturando(false)
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return setFacturando(false)
            } else if(res.salesInvoiceId){
                toast.success(`Emitido el documento ${res.salesInvoiceId}`)
                guardarUltimoDoc(res.salesInvoiceId)
                localStorage.setItem("tokenLaudus", res.token)
                limpiarCarrito()
                setTokenLaudus(res.token)
                return setTimeout(() => {
                  buscarPDF(res.salesInvoiceId, res.token)
                }, 500);
            } else if(res.salesWaybillId){
                toast.success(`Emitido el documento ${res.salesWaybillId}`)
                guardarUltimoDoc(res.salesWaybillId)
            } else if(res._id){
              if(payload.docType.docTypeId === 1000){
                toast.success(`Emitido el pedido ${res.id}`)
              } else if(payload.docType.docTypeId === 1001){
                toast.success(`Emitida la cotización ${res.id}`)
              } else {
                toast.success(`Emitido el registro #${res.id}`)
              }
                guardarUltimoDoc(res.id)
              }
              limpiarCarrito()
            return setFacturando(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            return setFacturando(false)
        })
    }

    const removerCarrito = (pos) => {
        if(props.onProductRemoved){
            props.onProductRemoved(pos)
        }
        return false
    }

    const validarDescuentos = async (ids_descuentos) => {
      const filtrar = ids_descuentos.filter(de => de)
      return fetch(`${urlapi}/descuentos/validar`,{
        method:'POST',
        body: JSON.stringify({
          ids_descuentos: filtrar
        }),
        headers: {
            'Content-Type':'application/json',
            'Authorization': `Bearer: ${user.tokenSession}`
        }
    })
    .then(res => {
        if(res.status === 401) return window.location = '/login'
        return res.json()
    })
    .then(res => {
        if(!res){
            toast.error('Sin datos de validez de descuento')
        } else if(res.errorMessage){
            toast.error(res.errorMessage)
        } else if(typeof res.allow !== "undefined"){
          return { allow: res.allow }
        }
        return { allow: false}
    })
    .catch(error => {
        return { allow: false }
    })
    }

    const buscarCliente = () => {
      const dato = formatoRut(rut)
      setLoadingBuscarCliente(true)
      setClienteSeleccionado(false)
      setClienteSeleccionadoDetalle(false)
      return fetch(`${urlapi}/clients/list`,{
        method:'POST',
        body: JSON.stringify({
          rut: dato
        }),
        headers: {
            'Content-Type':'application/json',
            'Authorization': `Bearer: ${user.tokenSession}`
        }
    })
    .then(res => {
        if(res.status === 401) return window.location = '/login'
        return res.json()
    })
    .then(res => {
        if(!res){
            toast.error('Sin datos')
        } else if(res.errorMessage){
            toast.error(res.errorMessage)
        } else if(Array.isArray(res) !== false){
            if(res.length < 1) toast.warn("Sin resultados encontrados")
            setListaClientes(res)
        }
        return setLoadingBuscarCliente(false)
    })
    .catch(error => {
        toast.error("Error al consultar métodos de pago, intente nuevamente")
        return setLoadingBuscarCliente(false)
    })
    }

    const handleChangeTerm = (e) => {
      const { value } = e.target
      return setTermId(value)
    }
    
    const handleChangeRut = (e) => {
      const { value } = e.target
      const valor_formateado = formatearRUTChileno(value)
      if(document.getElementById('rut_chileno')) document.getElementById('rut_chileno').value = valor_formateado
      return setRut(valor_formateado)
    }
    
    const handleChangeSalesMan = (e) => {
      const { value } = e.target
      return setSalesManId(value)
    }
    const handleChangePos = (e) => {
      const { value } = e.target
      return setPosId(value)
    }

    const seleccionarCliente = (client) => {
        setClienteSeleccionado(client.customerId)
        setClienteSeleccionadoDetalle(client)
        setDescuentoSeleccionado(false)
    }

    const handleChangeNombreCliente = (e) => {
      const { value } = e.target
      return setNombreCliente(value)
    }

    const buscarClienteMongobuscarClienteMongo = async () => {
      setLoadingBuscarCliente(true)
      setClienteSeleccionado(false)
      setClienteSeleccionadoDetalle(false)
      return fetch(`${urlapi}/clients/list-advance`,{
        method:'POST',
        body: JSON.stringify({
          condicion: { $text: { $search: nombreCliente } }
        }),
        headers: {
            'Content-Type':'application/json',
            'Authorization': `Bearer: ${user.tokenSession}`
        }
    })
    .then(res => {
        if(res.status === 401) return window.location = '/login'
        return res.json()
    })
    .then(res => {
        if(!res){
            toast.error('Sin datos')
        } else if(res.errorMessage){
            toast.error(res.errorMessage)
        } else if(Array.isArray(res.datos) !== false){
            if(res.datos.length < 1) toast.warn("Sin resultados encontrados")
            setListaClientes(res.datos)
        }
        return setLoadingBuscarCliente(false)
    })
    .catch(error => {
        toast.error("Error al consultar métodos de pago, intente nuevamente")
        return setLoadingBuscarCliente(false)
    })
    }

    const mostrarDetalleCliente = () => {
        return <div>
          <h4>{clienteSeleccionadoDetalle.name} {clienteSeleccionadoDetalle.vatId}</h4>
          <Button variant="warning" size="sm" onClick={() => {
            setClienteSeleccionadoDetalle(false)
            setClienteSeleccionado(false)
          }}>CAMBIAR CLIENTE</Button>
        </div>
    }

    const mostrarFormularioCliente = () => {
      if(!clienteEspecifico) return false
      if(clienteSeleccionadoDetalle) return mostrarDetalleCliente()
      return <Col md={12} className='mt-3'><Row className='justify-content-center'>
          <Col md={6} xs={12}>
          <input className='form-control mb-2' id="rut_chileno" placeholder='RUT. Ejemplo: 25691135-3'  onKeyUp={handleChangeRut} />
              {
                loadingBuscarCliente ? <Spinner animation='border' /> : <Button variant="success" className='mb-1 w-100' onClick={() => buscarCliente()} >BUSCAR CLIENTE</Button>
              }
          </Col>
          <Col className='mb-3' md={6} xs={12}>
          <input className='form-control mb-2' id="rut_chileno" placeholder='Nombre o Razón social'  onKeyUp={handleChangeNombreCliente} />
              <Button className='w-100' disabled={loadingBuscarCliente} onClick={() => buscarClienteMongobuscarClienteMongo()} >BUSCAR NOMBRE</Button>
          </Col>
          <Col xs={12}>
          <CrearEmpresa onCreatedNewCliente={(data) => {
                setListaClientes([data])
                setClienteSeleccionado(data.customerId)
                setClienteSeleccionadoDetalle(data)
              }} />
          {
            listaClientes.length > 0 ? <div>
              <Table className='w-100'>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Rut</th>
                  </tr>
                </thead>
                <tbody>
                {
                  listaClientes.map(cliente => {
                    return <tr key={`cliente-${cliente.customerId}`} className="hover" onClick={() => seleccionarCliente(cliente)}>
                      <th>
                        <p className='mb-0'>{clienteSeleccionado===cliente.customerId ? <i className="text-success fas fa-check-square"></i> : <i className="far fa-square"></i>} {cliente.name}</p>
                      </th>
                      <th><p className='mb-0'>{cliente.vatId}</p></th>
                    </tr>
                  })
                }
                </tbody>
              </Table>
            </div> : <div>
              
              {/* {
                rut ? <div>
                  <Button variant="success">CREAR NUEVO</Button>
                </div> : false
              } */}
            </div>
          }
          </Col>
        </Row></Col>

      return false
    }
    
    const handleChangeWareHouse = (value) => {
      return setWareHouseId(value)
    }

    const switchClienteEspecifico = () => {
      const valor = clienteEspecifico === true ? false : true
      setClienteEspecifico(valor)
    }
    
    const handleChangeBranchId = (e) => {
      const { value } = e.target
      return setBranchId(value)
    }

    const handleChangeTipoDoc = (e) => {
      const { value } = e.target
      return setTipoDoc(value)
    }

    const agregarPago = () => {
      if(allow_invoice_witouth_payment === true) return toast.error("Seleccionaste EMITIR SIN PAGO, desactivalo para poder añadir pagos")
      pagos.unshift({ tipo: "", monto: 0 })
      return setPagos(prev => [...[], ...pagos])
    }

    const maximo = (pos, monto_actual) => {
      let calcular_total = carrito.reduce((prev, next) => {
            let cantidad = parseInt(next.cantidad)
            if(isNaN(cantidad)) cantidad = 0
            return prev + (next.precio * cantidad)
        }, 0)

        let total_sumado = pagos.reduce((prev,next) => {
          let monto_pago = next.monto
          if(isNaN(parseInt(monto_pago))) monto_pago = 0
          return prev + monto_pago
        }, 0)

        let total_monto_actual = 0
        if(!isNaN(parseInt(monto_actual))) total_monto_actual = parseInt(monto_actual)
//        total_sumado = total_sumado + total_monto_actual

        if(total_sumado > calcular_total){
          return toast.error("El total sumado de los pagos es mayor al total del carrito")
        } else if (total_sumado === calcular_total){
          return false
        }

        const restante = calcular_total - total_sumado + total_monto_actual
        pagos[pos].monto = restante

        return setPagos(prev => [...[], ...pagos])

    }

    const handleChangeAmount = (e) => {
      const { value } = e.target
      const pos = parseInt(e.target.getAttribute('pos'))
      pagos[pos].monto = parseInt(value)
      return setPagos(prev => [...[], ...pagos])
    }

    const handleChangePago = (e) => {
      const { value } = e.target
      const pos = parseInt(e.target.getAttribute('pos'))
      pagos[pos].tipo = value
      return setPagos(prev => [...[], ...pagos])
    }

    const eliminar = (pos) => {
      pagos.splice(pos, 1)
      return setPagos(prev => [...[], ...pagos])
    }

    const accionesMetodoPago = () => {
      if(!autorizado) return false
      return <Button className='w-100' size="sm" variant="light" onClick={() => {
          setPagos(prev => [...[], ...[]])
          const nuevo_valor = allow_invoice_witouth_payment === true ? false : true
          return setAllowInvoiceWitouthPayment(nuevo_valor)
        }}>{allow_invoice_witouth_payment === true ? <i className="text-success fas fa-check-circle"></i> : false } EMITIR SIN PAGO</Button>
    }

    const mostrarEstadoAutorizacionPago = () => {
      if(autorizado === true) return <div className='mt-3'>
        <Card bg='warning' className='p-2'>
          <h6 className='mb-0' style={{ fontSize: 12 }}><i className="fas fa-exclamation-triangle"></i> ESTÁS AUTORIZADO PARA EMITIR DOCUMENTOS SIN PAGOS</h6>
        </Card>
      </div>
    }
    
    const mostrarMetodosPagoAgregados = () => {
      if(pagos.length < 1) return false
      return <div className='mt-2'>
        {
              pagos.map((pago,ip) => {
                let metodos = {}
                metodos_pago.map(m => metodos[m.key] = m.value)
                return <Badge variant='dark' className='mr-2' style={{ textTransform: "uppercase", fontWeight: "normal" }} key={`e-${ip+1}`}>{metodos[pago.tipo]} · {formatoMoneda(pago.monto)}</Badge>
              })
        }
      </div>
    }

    const mostrarModalPDF = () => {
      return <Modal show={showPDF} onHide={() => setShowPDF(false)} size="lg">
      <Modal.Header closeButton>Imprimir</Modal.Header>
      <Modal.Body>
        <div id="pdf_container"></div>
        {pdfFile && <PdfViewer file={pdfFile} />}
      </Modal.Body>
    </Modal>
    }

    const mostrarPagos = () => {

      return <div>
        <Row>
          <Col md={6}><Button size="sm" variant='light' className='w-100' onClick={() => setShowModalPagos(true)}><CiCreditCard1 /> MÉTODOS DE PAGO</Button></Col>
          <Col md={6}>{accionesMetodoPago()}</Col>
        </Row>
        
        {mostrarEstadoAutorizacionPago()}

        {mostrarMetodosPagoAgregados()}

        <Modal show={showModalPagos} onHide={() => setShowModalPagos(false)} size="lg">
          <Modal.Header closeButton>Pagos</Modal.Header>
          <Modal.Body>
          <Button size="sm" variant='outline-primary' className='w-100' onClick={() => agregarPago()}><CiCreditCard1 />AGREGAR MÉTODO DE PAGO</Button>
            {
              pagos.map((pago,ip) => {
                return <div key={`e-${ip+1}`}>
                  <Row>
                    <Col >
                      <label className='form-control-label'> Tipo de pago </label>
                      <select className='form-control' value={pago.tipo} pos={ip} onChange={handleChangePago}>
                        <option value="">Seleccione</option>
                        <option value="E">Efectivo</option>
                        <option value="I">Depósito en C/C - Transferencia</option>
                        <option value="T">Tarjeta de crédito</option>
                        <option value="D">Tarjeta de débito</option>
                      </select>
                      
                      <h6 className='mb-2 mt-2 hover text-danger' onClick={() => eliminar(ip)} ><i className="fas  fa-trash"></i> Remover</h6>
                    </Col>
                    <Col>
                    <label className='form-control-label'>Monto</label>
                    <input className='form-control' pos={ip} value={pago.monto} type="number" onChange={handleChangeAmount} />
                    <p className='mb-0 hover' style={{ position: "absolute", right: "30px", marginTop: -32 }} onClick={() => maximo(ip, pago.monto)}><b>MAX</b></p>
                    </Col>
                  </Row>
                </div>
              })
            }

          </Modal.Body>
        </Modal>
      </div>
    }

    const mostrarMetodosPago = () => {
      return mostrarPagos()
    }

    const removerProductosDeCotizacion = (id) => {

      const filtrar = carrito.filter(pro => {
        if(!pro.cotizacion) return true
        if(pro.cotizacion === id) return false
        return true
      })
      if(props.onChangeCarrito) props.onChangeCarrito(filtrar)
      return 
    }

    const removerProductosDePedido = (id) => {

      const filtrar = carrito.filter(pro => {
        if(!pro.pedido) return true
        if(pro.pedido === id) return false
        return true
      })
      if(props.onChangeCarrito) props.onChangeCarrito(filtrar)
      return 
    }

    const alertaDescuentos = producto => {
      if(!producto.descuentos) return false
      if(Array.isArray(producto.descuentos) !== true) return false
      if(producto.descuentos.length < 1) return false
      return <Card bg="secondary" className='p-1 text-center'><h6 style={{ fontSize: 11, color: "white" }} className='mb-0'>DESCUENTO APLICADO</h6></Card>
    }

    const mostrarCotizacionesAsociadas = () => {

      let cotizaciones_asociadas = []
      for(const pro of carrito){
        if(!pro.cotizacion) continue
        if(!cotizaciones_asociadas.includes(pro.cotizacion)) cotizaciones_asociadas.push(pro.cotizacion)
      }

      return <div>
        { cotizaciones_asociadas.length > 0 ? <Card className='p-2 mb-3'>
                        <h6 className='mb-2'><i className="fas fa-shopping-basket"></i> COTIZACIONES ASOCIADAS</h6>
                        {
                          cotizaciones_asociadas.map((pedido,i) => {
                            return <div key={`ped-${i}`}>
                              <Table className='mb-0'>
                                <thead>
                                  <tr>
                                    <th>COTIZACIÓN</th>
                                    <th>ACCION</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th>{pedido}</th>
                                    <th><Button size="sm" variant="danger" className='mb-0' onClick={() => removerProductosDeCotizacion(pedido)}>REMOVER PRODUCTOS DE ESTA COTIZACIÓN</Button></th>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                          })
                        }
            </Card> : false 
        }
      </div>
    }

    const mostrarPedidosAsociados = () => {

      let pedidos_asociados = []
      for(const pro of carrito){
        if(!pro.pedido) continue
        if(!pedidos_asociados.includes(pro.pedido)) pedidos_asociados.push(pro.pedido)
      }
      
      return <div>
        { pedidos_asociados.length > 0 ? <Card className='p-2 mb-3'>
                        <h6 className='mb-2'><i className="fas fa-shopping-basket"></i> PEDIDOS ASOCIADOS</h6>
                        {
                          pedidos_asociados.map((pedido,i) => {
                            return <div key={`ped-${i}`}>
                              <Table className='mb-0'>
                                <thead>
                                  <tr>
                                    <th>PEDIDO</th>
                                    <th>ACCION</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th>{pedido}</th>
                                    <th><Button size="sm" variant="danger" className='mb-0' onClick={() => removerProductosDePedido(pedido)}>REMOVER PRODUCTOS DE ESTE PEDIDO</Button></th>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                          })
                        }
            </Card> : false 
        }
      </div>
    }


    const headerCart = () => {

      

      return <div>
        <Card className='p-2 mb-2'>
        <Row >
      <Col xs={12}>
      <Row>
          { /* <Col md={3}>
              <label className='form-control-label'>Sucursal</label>
              <select className='form-control' onChange={handleChangeBranchId}>
                  <option value={1}>10 de Julio</option>
                  <option value={2}>San Isidro</option>
              </select>
          </Col> */ }
          <Col md={3}>
            <ConfiguracionSelector disable={user.data.allow_change_warehouse === true ? false : true} url_refresh={`${urlapi}/configuracion/sincronizar-bodegas`} tipo="bodega" subtipo="selector"  default_value={user.data.warehouseId} onChange={(e) => handleChangeWareHouse(e)} titulo={<div style={{ display: "inline" }}><PiWarehouse /> Bodega</div>} />
          </Col>
          <Col md={3} >
            <ConfiguracionSelector disable={user.data.allow_change_salesman === true ? false : true} url_refresh={`${urlapi}/configuracion/sincronizar-vendedores`} tipo="vendedor" subtipo="selector"  default_value={user.data.salesmanId} onChange={(e) => handleChangeSalesMan(e)} titulo="Vendedor" />          
          </Col>
          <Col md={3} >
            <ConfiguracionSelector disable={true} url_refresh={`${urlapi}/configuracion/sincronizar-cajas`} tipo="cajas" subtipo="selector"  default_value={user.data.posId} onChange={(e) => handleChangePos(e)} titulo="Caja integrada" />          
          </Col>
          <Col md={3} className='mb-3'>
              <label className='form-control-label'><FaFileInvoice /> Tipo de documento</label>
              <select className='form-control' onChange={handleChangeTipoDoc} value={tipoDoc}>
                  <option value={39}>Boleta electrónica</option>
                  <option value={33}>Factura electrónica</option>
                  <option value={52}>Guia de despacho electrónica</option>
                  <option value={1000}>Pedido para picking</option>
                  <option value={1001}>Cotización</option>
              </select>
          </Col>
          <Col xs={12}>
              {mostrarMetodosPago()}
          </Col>
          <Col className='mb-0' xs={12}>
          <Card className='p-2 text-center'>
          <HiOutlineIdentification size={40} style={{ margin: "0 auto" }} />
              <label className='form-control-label mb-0'>Cliente <b className='text-primary hover' onClick={() => switchClienteEspecifico()} >{clienteEspecifico === true ? "Seleccionar cliente genérico" : "Seleccionar cliente específico"}</b></label>
              {mostrarFormularioCliente()}
          </Card>
          </Col>
          {campoMotivo()}
          {campoFechaPedido()}
          
      </Row>
      </Col>
      <Col xs={12}>
          <div>
            {mostrarPedidosAsociados()}
            {mostrarCotizacionesAsociadas()}
          </div>
      </Col>
      
  </Row>
        </Card>
      </div>
    }

    const contentCart = () => {

      if(carrito.length < 1) return <div>
        <Row className='text-center justify-content-center'>
          <Col md={8}>
            <img src={`${url_images}/animations/Search Products.gif`} style={{ width: "30%" }} />
            <h4>Agrega productos aquí y luego facturalos</h4>
            <p>En el panel izquierdo podrás encontrar los productos, haz click para abrir los detalles y a continuación haz click en AGREGAR</p>
          </Col>
        </Row>
      </div>
      return <div>
        {/* <Button variant='light' className='w-100 mb-2' onClick={() => setShowPDF(true)}>MOSTRAR ÚLTIMO PDF</Button> */}

        {
                            carrito.map((pro,pos) => {

                                const cantidad = isNaN(parseInt(pro.cantidad)) ? 0 : parseInt(pro.cantidad)

                                return <div key={pro._id}>
                                        <Card className='p-3 mb-2'>
                                        <Row>
                                          <Col xs={3}>
                                            <div style={{ width: "100%", height: "100%", borderRadius: 4, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center", backgroundImage: `url(${pro.img ? pro.img : `${url_images}/product.png`})`}}></div>
                                          </Col>
                                          <Col xs={9}>
                                          <Row>
                                            <Col xs={12}>
                                              <Row>
                                                <Col md={8} xs={10}>
                                                <h6 className='mb-0'>{pro.titulo}</h6>
                                                <Badge variant='dark' className='mb-3'>{pro.codigo}</Badge>
                                                </Col>
                                                <Col md={4} xs={2} className='text-right'><FaRegTrashAlt color='#afafaf' className='hover' onClick={() => removerCarrito(pos)} /></Col>
                                              </Row>
                                            </Col>
                                            <Col xs={12}>
                                            
                                            {pro.pedido ? <Card bg="warning" className='p-1'><h6 className='p-0 m-0' style={{ fontSize:11 }}>ASOCIADO AL PEDIDO {pro.pedido}</h6></Card> : false}
                                            {pro.cotizacion ? <Card bg="warning" className='p-1'><h6 className='p-0 m-0' style={{ fontSize:11 }}>ASOCIADO A COTIZACIÓN {pro.cotizacion}</h6></Card> : false}
                                            
                                            </Col>
                                            
                                            <Col xs={12}>
                                              <hr className='mt-0'/>
                                              {alertaDescuentos(pro)}
                                              <Row className=''>
                                                <Col md={3} xs={4} className='text-left'>
                                                  <p className='mb-0' style={{ fontSize: 20 }}>${formatoMoneda(pro.precio)}</p>
                                                  <p className='mb-0' style={{ marginTop:-5, fontSize: 11 }}>X UNIDAD</p>
                                                </Col>
                                                <Col md={5} xs={4} className='text-center' style={{ background: "#f1efef", borderRadius: 5 }}>
                                                
                                                <FaCircleMinus size={20} className='hover' style={{ display: "inline-block", width: "15%" }} onClick={() => operacionMath('-', pro._id)} />
                                                <input className='form-control text-center inputcantidad' style={{ backgroundColor: "transparent", border:"none", padding: "0px !important", display: "inline-block", width: "50%" }} value={pro.cantidad} type="number" name={pro._id} onChange={handleChangeCantidad} />
                                                <FaCirclePlus size={20} className='hover' style={{ display: "inline-block", width: "15%" }} onClick={() => operacionMath('+', pro._id)} />
                                                </Col>
                                                <Col md={4} xs={4} className='text-right'>
                                                <p className='mb-0' style={{ fontSize: 20 }}>${formatoMoneda(cantidad * pro.precio)}</p>
                                                <p className='mb-0' style={{ marginTop:-5, fontSize: 11 }}>SUB TOTAL</p>
                                                </Col>
                                              </Row>
                                            </Col>
                                          </Row>
                                          </Col>
                                        </Row>
                                      </Card>
                                    </div>
                            })
                        }
      </div>
    }

    const footerCart = () => {
      let calcular_total = carrito.reduce((prev, next) => {
        let cantidad = parseInt(next.cantidad)
        if(isNaN(cantidad)) cantidad = 0
        return prev + (next.precio * cantidad)
    }, 0)
      return <div>
      { facturando ? <div style={{ position: "fixed", bottom: 0, left: 0, width: "100%", padding: 40, textAlign: "center", boxShadow: "3px 13px 33px 13px black", zIndex:999, background: "white" }}><Spinner animation='border' /><h5>{mensajeFacturando}</h5></div> : false } 
      <Button disabled={facturando} style={{ width: '100%', height: 50, fontSize: 15 }} onClick={() => facturar()} ><IoReceiptOutline /> EMITIR DTE ${formatoMoneda(calcular_total)}</Button>
          <div id="pdf-container" style={{ width: "100%" }}></div>
      </div>
    }
    const mostrarCarrito = () => {

        

        return <div >
              { typeof ultimoDocGenerado !== "undefined" && tokenLaudus ? <Card className="p-3 mb-3 text-light" bg="dark"><h6 className='mb-0'>Último documento generado {ultimoDocGenerado} <Button onClick={() => buscarPDF(ultimoDocGenerado, tokenLaudus)} >IMPRIMIR</Button> </h6></Card> : false }
              <div style={{ height: "78vh", overflowY: "scroll", overflowX: "hidden" }}>
              {headerCart()}
              {contentCart()}
              </div>
              <div style={{ height: "10vh",  }}>{footerCart()}</div>
              
        </div>
    }

    return <div>
        {mostrarModalPDF()}
        {mostrarCarrito()}
    </div>
}

export default Carrito